import script from "./ExportTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportTable.vue?vue&type=script&lang=ts&setup=true"

import "./ExportTable.vue?vue&type=style&index=0&id=44a8d7be&lang=scss"

const __exports__ = script;

export default __exports__